import { Editor } from '@tldraw/tldraw'
import { createContext, useContext } from 'react'

export const VisualEditorContext = createContext<Editor | undefined>(undefined)

export const useEditor = () => {
  const editor = useContext(VisualEditorContext)

  if (!editor) throw new Error(`useEditor must be within VisualEditorContext.Provider`)

  return editor
}
